<template>
  <span v-if="label === 'A+'">
    ~ -100 - 0 kWh/m² jaar.
  </span>
  <span v-else-if="label === 'A'">
    ~ 0 - 100 kWh/m² jaar.
  </span>
  <span v-else-if="label === 'B'">
    ~ 100 - 200 kWh/m² jaar.
  </span>
  <span v-else-if="label === 'C'">
    ~ 200 - 300 kWh/m² jaar.
  </span>
  <span v-else-if="label === 'D'">
    ~ 300 - 400 kWh/m² jaar.
  </span>
  <span v-else-if="label === 'E'">
    ~ 400 - 500 kWh/m² jaar.
  </span>
  <span v-else-if="label === 'F'">
    ~ 500+ kWh/m² jaar.
  </span>
</template>

<script>
export default {
  name: 'KWH',
  data: function () {
    return {
    }
  },
  props: ['label']
}
</script>
